function SearchArea(props: any) {
  let myProps = {
    listOpt: {},
    setListOpt: (inData: any) => { },
    list: (inData: any) => { },
    is_now_period:false,
    ...props
  };
  let listOpt = myProps.listOpt;

  return (
    <div className="my_flex_left">
      <label>
        <input type="checkbox" value="" className="search-input"
          checked={myProps.is_now_period}
          name="s_in_now_period"
          onChange={(e: any) => {
            myProps.set_is_now_period(e.target.checked);
          }} />
        <span className="ml-1">사용중인교재</span>
      </label>
      <button className="btn btn-dark"
        onClick={() => { myProps.list({}); }}>검색</button>
    </div>
  );
};
export default SearchArea;